export enum ClientStatus {
  INIT,
  CONNECTING,
  CONNECTED,
}

const state = {
  status: ClientStatus.INIT,
};

export type StateType = typeof state;
export default state;
